<template>
  <div class="ll-display-list">
    <div v-if="title" class="ll-display-list_title-wrap" @click="$_onToggleCollapse()">
      <div class="ll-display-list__title-left">
        <i
          v-if="leadingIcon"
          class="leadingIcon"
          :style="{color:leadingIconColor}"
          :class="leadingIcon"
        />
        <img
          v-if="iconImg"
          :src="iconImg"
          alt=""
          class="icon-img"
        >
        <LvText
          h5
          bold
          class="ml-4"
        >
          {{ $t(title) }}
        </LvText>
      </div>
      <i
        v-if="isCollapsable"
        :class="_icon"
        class="ll-display-list__collapse-icon"
      />
    </div>
    <component :is="_component" :active="isCollapse" class="ll-display-list_content">
      <DotLoading v-if="!itemList.length && isLoading" />
      <div v-else-if="itemList.length">
        <div
          v-for="(item,itemIndex) in itemList"
          :key="itemIndex"
          class="ll-display-list_content-item"
          @click="$_onClick(item)"
        >
          <i
            v-if="leadingIcon"
            class="leadingIcon"
            :class="leadingIcon"
            :style="{color:leadingIconColor}"
          />
          <img
            v-if="iconImg"
            :src="iconImg"
            alt=""
            class="icon-img"
          >
          <div class="ml-4">
            <WsFlex>
              <div
                class="ll-display-list_content-text"
                :class="{ellipsis:ellipsis}"
              >
                {{ item.title }}
              </div>
              <div
                v-if="item.totalNum"
                class="ll-display-list_content-number"
              >
                {{ item.totalNum }}
              </div>
              <ContentChip
                v-if="item.badge && item.badge.text"
                :text-label="item.badge.text"
                :color="item.badge.color"
              />
              <NumberList
                v-if="item.numberList && item.numberList.length > 0"
                :item-list="item.numberList"
              />
            </WsFlex>
            <WsChips001
              class="mt-4"
              :value="item.tags"
            />
            <LvText v-if="item.areaDisplayText" h5>{{ item.areaDisplayText }}</LvText>
            <LvText v-if="item.date" h5>{{`${$t(dateTitle)} ${item.date}`}}</LvText>
          </div>
        </div>
      </div>
      <LlEmptyPic
        v-if="!itemList.length && !isLoading"
        :title="emptyText"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
      />
      <WsButton001
        v-if="isShowLoadBtn && itemList.length && !isLoading"
        outLine
        class="ll-display-list__load-btn"
        @click="$emit('load-more')"
      >
        {{ $t('載入更多') }}
      </WsButton001>
      <DotLoading v-if="isShowLoadBtn && itemList.length && isLoading" />
    </component>
  </div>
</template>
<script>
export default {
  props: {
    leadingIconColor: {
      type: String,
      default: "#0585d3",
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    iconImg: {
      type: String,
      default: "",
    },
    badge: {
      type: Boolean,
      default: false,
    },
    ellipsis: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    nonCursor: {
      type: Boolean,
      default: false,
    },
    isCollapsable: {
      type: Boolean,
      default: false,
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isShowLoadBtn: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '目前尚無資料'
    },
    dateTitle: {
      type: String,
      default: '生效日'
    }
  },
  computed: {
    _component() {
      return this.isCollapsable ? 'slide-up-down' : 'div';
    },
    _icon() {
      return this.isCollapse ? 'icon-chevron-up' : 'icon-chevron-down';
    }
  },
  methods: {
    $_onClick(item) {
      this.$emit("list-click", item);
    },
    $_onToggleCollapse() {
      if (!this.isCollapsable) return;
      this.$emit('toggle-collapse', !this.isCollapse);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-display-list";
</style>